import type { ChatsV2Translations } from '../interfaces/chatsV2';

export const chatsV2Translations: ChatsV2Translations = {
  page_title: 'Chats',

  inbox_all: 'Todos',
  inbox_mine: 'Asignados a mí',
  inbox_unread: 'Sin leer',
  inbox_handoff: 'Esperan humano',
  inbox_closed: 'Cerrados',

  channel_all: 'Todos los canales',
  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram',
  channel_web: 'Web Chat',
  channel_messenger: 'Messenger',

  account_all_label: 'Todas las cuentas',
  account_select_label: 'Cuenta',

  search_placeholder: 'Buscar conversaciones, números, emails…',
  new_conversation: 'Nueva conversación',
  toggle_context_show: 'Mostrar detalles',
  toggle_context_hide: 'Ocultar detalles',

  conversation_count: '{{count}} conversaciones',
  sort_recent: 'Recientes',
  sort_priority: 'Prioritarios',

  header_take_over: 'Tomar control',
  header_auto_on: 'Auto',
  header_auto_off: 'Pausado',
  header_auto_paused_notice:
    'Auto-respuesta pausada. El agente no contestará. Cualquier mensaje saldrá de tu cuenta.',
  header_resume: 'Reanudar',

  composer_placeholder:
    'Escribe un mensaje, o usa / para insertar una plantilla…',
  composer_reply_as: 'Responder como:',
  composer_reply_as_human: 'humano',
  composer_reply_as_agent: 'agente',
  composer_send: 'Enviar',
  composer_outbound_via: 'Saldrá por',
  composer_attach: 'Adjuntar',
  composer_window_expired_hint: "Han pasado más de 24 h desde el último mensaje del cliente. Solo puedes enviar una plantilla aprobada.",
  composer_window_never_hint: "El cliente aún no ha escrito. Para iniciar la conversación tienes que enviar una plantilla aprobada.",
  composer_window_closing: "La ventana de 24 h cierra en {{hours}} h",
  composer_send_template: "Enviar plantilla",
  template_sent_notice: "Enviar una plantilla no reabre la ventana de 24 h — solo lo hace una respuesta del cliente.",
  composer_templates: 'Plantillas',
  composer_send_checkout: 'Enviar checkout',

  lead_score_label: 'Lead score',
  lead_hot: 'Hot',
  lead_warm: 'Warm',
  lead_cold: 'Cold',
  lead_score_intent: 'Intención',
  lead_score_engagement: 'Engagement',
  lead_score_budget: 'Presupuesto',
  lead_score_urgency: 'Urgencia',
  lead_score_pending: 'Pendiente análisis',
  data_collected_empty: 'Aún no se ha recolectado información del lead',
  actions_empty: 'Sin acciones registradas todavía',
  context_force_analyze: 'Forzar análisis',
  context_analyzing: 'Analizando…',
  context_analyze_error: 'No se pudo encolar el análisis',
  context_empty_title: 'Selecciona una conversación',
  context_empty_description:
    'El detalle del lead, las acciones del agente y las notas internas aparecerán aquí cuando elijas un chat de la lista.',
  send_failed: 'No se pudo enviar el mensaje',
  composer_placeholder_locked:
    'Pausa el agente para responder manualmente desde aquí',
  composer_locked_hint: 'El agente está respondiendo automáticamente',
  header_pause_agent: 'Pausar agente',
  header_resume_agent: 'Reanudar agente',
  header_paused_notice:
    'El agente está pausado. Tus mensajes se enviarán como humano hasta que reanudes.',
  notes_save: 'Guardar nota',
  notes_saved: 'Nota guardada',
  notes_save_error: 'No se pudo guardar la nota',
  message_human_sent_by: 'Enviado por',
  system_event_human_takeover: 'El operador tomó el control',
  system_event_human_released: 'El operador devolvió el control al agente',
  system_event_handoff_triggered: 'El agente solicitó intervención humana',
  system_event_agent_error: 'El agente tuvo un error procesando el mensaje',
  system_event_follow_up_dispatched: 'Se envió un follow-up automático',
  system_event_conversation_closed: 'Conversación cerrada',

  stage_label: 'Etapa',
  stage_contact: 'Contacto',
  stage_qualified: 'Calificado',
  stage_quote: 'Cotización',
  stage_close: 'Cierre',

  data_collected_title: 'Datos recolectados',
  data_collected_edit: 'Editar',
  actions_title: 'Acciones del agente',
  notes_title: 'Notas internas',
  notes_placeholder: 'Solo visible para el equipo…',

  context_action_profile: 'Perfil',
  context_action_tag: 'Etiqueta',
  context_action_close: 'Cerrar',

  tab_lead: 'Lead',
  tab_history: 'Historial',
  tab_actions: 'Acciones',
  tab_history_placeholder: 'Historial completo del cliente próximamente.',
  tab_actions_placeholder: 'Acciones rápidas próximamente.',

  ai_suggestion_eyebrow: 'Sugerencia del agente',
  ai_suggestion_apply: 'Aplicar',
  ai_suggestion_dismiss: 'Descartar',

  typing_label: 'está escribiendo…',
  today_pill: 'Hoy',
  empty_state_title: 'Selecciona una conversación',
  empty_state_description: 'Elige un chat de la lista para ver el detalle.',
};
